import { useLocation } from "react-router-dom";

import useSettingsNavItems from "./useSettingsNavItems";

export default function useCurrentSettingsRoute() {
  const { pathname } = useLocation();
  const { routes } = useSettingsNavItems();

  let currentRoute = routes.find(
    ({ path }) => path && pathname.includes(path.replace("/*", "")),
  );
  if (!currentRoute) {
    currentRoute = routes[0];
  }

  if (!currentRoute) {
    return { label: undefined, bannerComponent: undefined };
  }

  return {
    label: currentRoute.label,
    bannerComponent:
      "bannerComponent" in currentRoute && currentRoute.bannerComponent,
  };
}
